var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("select-dialog", {
    ref: "selectDialog",
    attrs: {
      title: _vm.title,
      "row-data": _vm.rowData,
      "column-defs": _vm.columnDefs,
      "filter-keys": ["name", "documentTypeUuidStr"],
      value: _vm.finalBatchTemplateUuid,
      "event-name": _vm.eventName,
      "display-name-field": _vm.displayNameField,
      "show-office": true
    },
    on: { change: _vm.changeTrigger, selected: _vm.selectedHandle }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }